export const unitedStatesForFilter = [
  { value: 'AL', key: 'AL'},
  { value: 'AK', key: 'AK' },
  { value: 'AS', key: 'AS' },
  { value: 'AZ', key: 'AZ' },
  { value: 'AR', key: 'AR' },
  { value: 'CA', key: 'CA' },
  { value: 'CO', key: 'CO' },
  { value: 'CT', key: 'CT' },
  { value: 'DE', key: 'DE' },
  { value: 'DC', key: 'DC' },
  { value: 'FM', key: 'FM' },
  { value: 'FL', key: 'FL' },
  { value: 'GA', key: 'GA' },
  { value: 'GU', key: 'GU' },
  { value: 'HI', key: 'HI' },
  { value: 'ID', key: 'ID' },
  { value: 'IL', key: 'IL' },
  { value: 'IN', key: 'IN' },
  { value: 'IA', key: 'IA' },
  { value: 'KS', key: 'KS' },
  { value: 'KY', key: 'KY' },
  { value: 'LA', key: 'LA' },
  { value: 'ME', key: 'ME' },
  { value: 'MH', key: 'MH' },
  { value: 'MD', key: 'MD' },
  { value: 'MA', key: 'MA' },
  { value: 'MI', key: 'MI' },
  { value: 'MN', key: 'MN' },
  { value: 'MS', key: 'MS' },
  { value: 'MO', key: 'MO' },
  { value: 'MT', key: 'MT' },
  { value: 'NE', key: 'NE' },
  { value: 'NV', key: 'NV' },
  { value: 'NH', key: 'NH' },
  { value: 'NJ', key: 'NJ' },
  { value: 'NM', key: 'NM' },
  { value: 'NY', key: 'NY' },
  { value: 'NC', key: 'NC' },
  { value: 'ND', key: 'ND' },
  { value: 'MP', key: 'MP' },
  { value: 'OH', key: 'OH' },
  { value: 'OK', key: 'OK' },
  { value: 'OR', key: 'OR' },
  { value: 'PW', key: 'PW' },
  { value: 'PA', key: 'PA' },
  { value: 'PR', key: 'PR' },
  { value: 'RI', key: 'RI' },
  { value: 'SC', key: 'SC' },
  { value: 'SD', key: 'SD' },
  { value: 'TN', key: 'TN' },
  { value: 'TX', key: 'TX' },
  { value: 'UT', key: 'UT' },
  { value: 'VT', key: 'VT' },
  { value: 'VI', key: 'VI' },
  { value: 'VA', key: 'VA' },
  { value: 'WA', key: 'WA' },
  { value: 'WV', key: 'WV' },
  { value: 'WI', key: 'WI' },
  { value: 'WY', key: 'WY' }
];

export const establishmentStatusForFilter = [
  { value: 1, key: 'Not Added' },
  { value: 2, key: 'Not Submitted' },
  { value: 3, key: 'Submitted' }
];

// export const unitedStatesForFilter = [
//   { value: 'AL', key: 'Alabama'},
//   { value: 'AK', key: 'Alaska' },
//   { value: 'AS', key: 'American Samoa' },
//   { value: 'AZ', key: 'Arizona' },
//   { value: 'AR', key: 'Arkansas' },
//   { value: 'CA', key: 'California' },
//   { value: 'CO', key: 'Colorado' },
//   { value: 'CT', key: 'Connecticut' },
//   { value: 'DE', key: 'Delaware' },
//   { value: 'DC', key: 'District Of Columbia' },
//   { value: 'FM', key: 'Federated States Of Micronesia' },
//   { value: 'FL', key: 'Florida' },
//   { value: 'GA', key: 'Georgia' },
//   { value: 'GU', key: 'Guam' },
//   { value: 'HI', key: 'Hawaii' },
//   { value: 'ID', key: 'Idaho' },
//   { value: 'IL', key: 'Illinois' },
//   { value: 'IN', key: 'Indiana' },
//   { value: 'IA', key: 'Iowa' },
//   { value: 'KS', key: 'Kansas' },
//   { value: 'KY', key: 'Kentucky' },
//   { value: 'LA', key: 'Louisiana' },
//   { value: 'ME', key: 'Maine' },
//   { value: 'MH', key: 'Marshall Islands' },
//   { value: 'MD', key: 'Maryland' },
//   { value: 'MA', key: 'Massachusetts' },
//   { value: 'MI', key: 'Michigan' },
//   { value: 'MN', key: 'Minnesota' },
//   { value: 'MS', key: 'Mississippi' },
//   { value: 'MO', key: 'Missouri' },
//   { value: 'MT', key: 'Montana' },
//   { value: 'NE', key: 'Nebraska' },
//   { value: 'NV', key: 'Nevada' },
//   { value: 'NH', key: 'New Hampshire' },
//   { value: 'NJ', key: 'New Jersey' },
//   { value: 'NM', key: 'New Mexico' },
//   { value: 'NY', key: 'New York' },
//   { value: 'NC', key: 'North Carolina' },
//   { value: 'ND', key: 'North Dakota' },
//   { value: 'MP', key: 'Northern Mariana Islands' },
//   { value: 'OH', key: 'Ohio' },
//   { value: 'OK', key: 'Oklahoma' },
//   { value: 'OR', key: 'Oregon' },
//   { value: 'PW', key: 'Palau' },
//   { value: 'PA', key: 'Pennsylvania' },
//   { value: 'PR', key: 'Puerto Rico' },
//   { value: 'RI', key: 'Rhode Island' },
//   { value: 'SC', key: 'South Carolina' },
//   { value: 'SD', key: 'South Dakota' },
//   { value: 'TN', key: 'Tennessee' },
//   { value: 'TX', key: 'Texas' },
//   { value: 'UT', key: 'Utah' },
//   { value: 'VT', key: 'Vermont' },
//   { value: 'VI', key: 'Virgin Islands' },
//   { value: 'VA', key: 'Virginia' },
//   { value: 'WA', key: 'Washington' },
//   { value: 'WV', key: 'West Virginia' },
//   { value: 'WI', key: 'Wisconsin' },
//   { value: 'WY', key: 'Wyoming' }
// ];

export const caseDataCaseClassification = [
  { value: 1, key: 'Death' },
  { value: 2, key: 'Days away from work' },
  { value: 3, key: 'Job transfer or restriction' },
  { value: 4, key: 'Other recordable cases' }
];

export const caseDataInjuryType = [
  { value: 1, key: 'Injury' },
  { value: 2, key: 'Skin Disorder' },
  { value: 3, key: 'Respiratory condition' },
  { value: 4, key: 'Poisoning' },
  { value: 5, key: 'Hearing Loss' },
  { value: 6, key: 'All other illness' }
]; 



/** WEBPACK FOOTER **
 ** ./src/constants/FilterSelectLists.js
 **/